import Template from "../../component/Template";
import SchoolIcon from "@mui/icons-material/School";
import Api from "../../component/Api";
import React, { useState, useEffect, useRef } from "react";
import useAuth from "../../component/useAuth";
import PeopleIcon from "@mui/icons-material/People";
import { formatDistanceToNow, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

export default function Dashboard() {
  const isAuth = useAuth();
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/college/");
  }
  const { http } = Api();

  const [activeRecordsCount, setActiveRecordsCount] = useState(0);
  const [activeRecordsCountDis, setActiveRecordsCountDis] = useState(0);
  const [activeRecordsCountSpec, setActiveRecordsCountSpec] = useState(0);
  const [activeRecordsCountCourse, setActiveRecordsCountCourse] = useState(0);
  const [activeRecordsCountUsers, setActiveRecordsCountUsers] = useState(0);
  const [activeRecordsCountColleges, setActiveRecordsCountColleges] =
    useState(0); //02/04/2024
  const [userlog, setUserLogData] = useState([]);

  const [flag, setflag] = useState(0);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  //20/3/2024
  const [isviewcount, setViewCount] = useState(false);
  const [isviewlog, setViewLog] = useState(false);
  const [activeTab, setActiveTab] = useState("instruction_wizard");
  const [noti, setNoti] = useState([]);
  const [inst, setInst] = useState([]);
  const [notisubject, setNotiSubject] = useState(null);
  const [notimessage, setNotiMessage] = useState(null);
  const [msgtatus, setStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [isScrollMessageVisible, setScrollMessageVisible] = useState(false);

  const [scrollMessage, setScrollMessage] = useState(""); // State to store the message
  const [collegeMainScrollMessage, setCollegeMainScrollMessage] = useState([]);
  const marqueeRef = useRef(null); // Create a reference to the marquee element

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }

  //role validation -20/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get("/Admin/get-all-user-permissions", {
          params: { user_id: id },
        });
        //console.log("response",response);
        const permissions = response.data;
        //console.log("permissions"+response.data);
        permissions.forEach((permission) => {
          if (permission.name === "view-dashboardcount") {
            setViewCount(true);
          }

          if (permission.name === "view-recentuserlogs") {
            setViewLog(true);
          }
        });
      } catch (error) {
        setViewCount(false);
        setViewLog(false);
      }
    };
    access();
  }, []);

  const college_id = localStorage.getItem("collegeid");

  //new api end point connected- 11/03/2024
  useEffect(() => {
    const fetchData = async () => {
      const { http } = Api();
      const id1 = localStorage.getItem("id");

      await http
        .get(`/Admin/getRecentUserActions/${id1}`)
        .then((response) => {
          if (response.data.recentUserActions) {
            setUserLogData(response.data.recentUserActions);
            setflag(1);
          } else {
            setflag(0);
          }
        })
        .catch((error) => {
          console.error("Error fetching user log data:", error);
          setflag(0);
        });

      try {
        const response1 = await http.get(`/Admin/getNotificationsAndMessages`);

        if (response1.data.status_code !== "ERR5") {
          setNoti((previous) => {
            const filteredNotifications = response1.data.filter(
              (option) => option.msg_type === "notification"
            );
            return filteredNotifications;
          });

          setInst((previous) => {
            const filteredinstruction = response1.data.filter(
              (option) => option.msg_type === "instruction"
            );
            console.log(filteredinstruction);
            return filteredinstruction;
          });
        } else {
          setInst([]);
          setNoti([]);
        }
      } catch (error) {
        console.error("Error fetching notification:", error);
      }

      try {
        setLoading(true);

        const response = await http.get(
          `/Admin/getcollegedashboardcount?college_id=${college_id}`
        );

        if (response.data.status_code === "ERR5") {
          setActiveRecordsCount(0);
          setActiveRecordsCountDis(0);
          setActiveRecordsCountSpec(0);
          setActiveRecordsCountCourse(0);
          setActiveRecordsCountUsers(0);
        } else {
          setActiveRecordsCount(response.data.facultyCount);
          setActiveRecordsCountDis(response.data.disciplineCount);
          setActiveRecordsCountSpec(response.data.specialisationCount);
          setActiveRecordsCountCourse(response.data.courseCount);
          setActiveRecordsCountUsers(response.data.usersCount);
          setActiveRecordsCountColleges(response.data.collegeCount); //02/04/2024
        }
        setError(null); // Clearing any previous errors
      } catch (error) {
        setError("Error fetching data. Please try again later."); // Setting error message
        console.error("Error fetching data:", error);
        setActiveRecordsCount(0);
        setActiveRecordsCountDis(0);
        setActiveRecordsCountSpec(0);
        setActiveRecordsCountCourse(0);
        setActiveRecordsCountUsers(0);
        setActiveRecordsCountColleges(0); //02/04/2024
      } finally {
        setLoading(false); // Resetting loading state
      }
    };
    if (isAuth) {
      fetchData();
    }
  }, []);

  const reload = async () => {
    try {
      const { http } = Api();
      const response1 = await http.get(`/Admin/getNotificationsAndMessages`);

      if (response1.data.status_code !== "ERR5") {
        setNoti((previous) => {
          const filteredNotifications = response1.data.filter(
            (option) => option.msg_type === "notification"
          );
          return filteredNotifications;
        });

        setInst((previous) => {
          const filteredinstruction = response1.data.filter(
            (option) => option.msg_type === "instruction"
          );
          return filteredinstruction;
        });
      } else {
        setInst([]);
        setNoti([]);
      }
    } catch (error) {
      console.error("Error fetching instruction or notification:", error);
    }
  };

  // console.log("notification=", noti);
  // console.log("inst=", inst);
  // Function to format the date to a relative format
  const formatRelativeDate = (dateString) => {
    const parsedDate = parseISO(dateString);
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  };

  const currentDateTime = new Date({});
  //console.log("d", currentDateTime);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleViewModalOpen = (
    instaid,
    notisubject,
    notimessage,
    msgstatus
  ) => {
    setNotiSubject(notisubject);
    setNotiMessage(notimessage);

    setShowModal(true);

    const messagedata = async (instaid) => {
      const { http } = Api();

      await http
        .post(`/Admin/markAsRead`, {
          id: instaid,
        })
        .then((response) => {
          if (response.data.status_code === "MSG2") {
            reload();
          }
        })
        .catch((error) => {
          console.error("Error fetching Instructions:", error);
        });
    };

    if (msgstatus == "sent") {
      messagedata(instaid);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    // Call the API to get the scroll message
    const fetchScrollMessage = async () => {
      try {
        const response = await http.get("/College/getScrollMessage");

        if (response.status === 200 && response.data.message) {
          setScrollMessageVisible(true); // Show marquee if API status is 200
          setScrollMessage(response.data.message); // Set the message from the API response
        } else {
          setScrollMessageVisible(false); // Hide marquee if API doesn't return status 200
        }
      } catch (error) {
        console.log("error", error);
        setScrollMessageVisible(false);
      }
    };

    fetchScrollMessage();
  }, []);

  useEffect(() => {
    const collegeMainScrollMessage = async () => {
      http
        .get("/Admin/getScrollMessages")
        .then((response) => {
          if (response.data.scrollmessages.length > 0) {
            const newmessages = response.data.scrollmessages.map(
              (msg) =>
                `<i class="fa fa-bullhorn" aria-hidden="true"></i> ${msg.message} `
            );
            const combinedMessage = newmessages.join(" ");

            setCollegeMainScrollMessage([combinedMessage]);
          } else {
            toast.error("Main scroll messages not found");
          }
        })
        .catch((error) => {
          console.log("error", error);
          setCollegeMainScrollMessage([]);
          // const responseData = error.response?.data;
          // if (!responseData) {
          //   console.log("No response data", error);
          //   toast.error("An unknown error occurred");
          //   return;
          // }

          // const status = responseData?.http_status;
          // const message = responseData?.message || "An error occurred";
          // console.log("Error message:", message);

          // if (status === 500 || responseData?.status_code === "ERR5") {
          //   toast.error("Scroll Messages not found");
          // } else if (status === 403 && responseData?.status_code === "ERR37") {
          //   toast.error("Invalid Token");
          //   setTimeout(() => navigate("/college/"), 5000);
          // } else {
          //   toast.error(message);
          // }
        });
    };
    collegeMainScrollMessage();
  }, []);

  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.style.animationPlayState = "running";
    }
  };

  return (
    <>
      <Template>
        <ToastContainer />

        <div
          style={{ backgroundColor: "#7a787878" }}
          class={`modal fade bd-example-modal-lg ${
            showModal ? "show d-block" : ""
          }`}
          tabindex="-1"
          role="dialog"
          aria-labelledby="myExtraLargeModal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myExtraLargeModal">
                  {notisubject}
                </h4>
                <button
                  class="btn-close py-0"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleModalClose()}
                ></button>
              </div>
              <div class="modal-body dark-modal">
                <div class="large-modal-header">
                  <i data-feather="chevrons-right"></i>
                  {/* <h6>{notisubject}</h6> */}
                </div>
                <p
                  class="modal-padding-space mb-0"
                  dangerouslySetInnerHTML={{ __html: notimessage }}
                ></p>
              </div>
            </div>
          </div>
        </div>

        {/* Container-fluid start*/}
        <div className="container-fluid">
          <div className="mar2">
            {isviewcount && (
              <div className="col-xxl-12 col-xl-12 box-col-12 pdg11">
                <div className="row g-sm-3 height-equal-2 widget-charts">
                  <div className="col-sm-4">
                    <div className="card small-widget mb-sm-0">
                      <div className="card-body primary">
                        {" "}
                        <span className="f-light">Faculties</span>
                        <div className="d-flex align-items-end gap-1">
                          <h4>{loading ? "Loading..." : activeRecordsCount}</h4>
                        </div>
                        <div className="bg-gradient">
                          <svg className="stroke-icon svg-fill">
                            <SchoolIcon sx={{ color: "#581f37" }} />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="card small-widget mb-sm-0">
                      <div className="card-body warning">
                        <span className="f-light">Disciplines</span>
                        <div className="d-flex align-items-end gap-1">
                          <h4>
                            {loading ? "Loading..." : activeRecordsCountDis}
                          </h4>
                        </div>
                        <div className="bg-gradient">
                          <svg className="stroke-icon svg-fill">
                            <SchoolIcon sx={{ color: "#581f37" }} />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="card small-widget mb-sm-0">
                      <div className="card-body secondary">
                        <span className="f-light">Courses</span>
                        <div className="d-flex align-items-end gap-1">
                          <h4>
                            {loading ? "Loading..." : activeRecordsCountCourse}
                          </h4>
                        </div>
                        <div className="bg-gradient">
                          <svg className="stroke-icon svg-fill">
                            <SchoolIcon sx={{ color: "#581f37" }} />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-xxl-12 col-xl-12 box-col-12">
              <div className="row">
                <div className="col-sm-12">
                  {collegeMainScrollMessage.length > 0 && (
                    <div className="card">
                      <div className="card-body pt-2">
                        <div className="slider-wrapper arrow-round">
                          <div className="swiper category-slider">
                            <div className="swiper-wrapper marquee-container">
                              <marquee
                                behavior="scroll"
                                direction="left"
                                scrollamount="13"
                                ref={marqueeRef}
                                onMouseOver={handleMouseOver}
                                onMouseOut={handleMouseOut}
                              >
                                <div className="marquee-content">
                                  {collegeMainScrollMessage.length > 0 && (
                                    <div
                                      style={{
                                        display: "inline-block",
                                        marginRight: "20px",
                                      }}
                                    >
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "18px",
                                        }}
                                      >
                                        {/* <i className="fa fa-bullhorn" aria-hidden="true"></i> &nbsp; */}
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: collegeMainScrollMessage[0],
                                          }}
                                        ></span>
                                        {/* &nbsp;&nbsp;
                                  <a href='https://ugpapi.mgu.ac.in/ugp/docs/Course_Outcome_Mapping_and_CCA_Mark_Entry.pdf' target='_blank'>Click here for step by step instructions.</a> &nbsp;&nbsp;
                                  <i className="fa fa-bullhorn" aria-hidden="true"></i>
                                  &nbsp;OTP for QP download will be available from 9:00 AM. QP can be downloaded between 9:30 AM and 10:15 AM. &nbsp;&nbsp; 
                                      &nbsp;*/}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </marquee>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* {isScrollMessageVisible && ( */}
            <div className="col-xxl-12 col-xl-12 box-col-12">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body pt-2">
                      <div className="slider-wrapper arrow-round">
                        <div className="swiper category-slider">
                          <div className="swiper-wrapper">
                            <marquee behavior="scroll" direction="left">
                              <div
                                style={{
                                  display: "inline-block",
                                  marginRight: "20px",
                                }}
                              >
                                <p style={{ color: "red", fontSize: "18px" }}>
                                  <i
                                    className="fa fa-bullhorn"
                                    aria-hidden="true"
                                  ></i>
                                  &nbsp; The CCA Score Entry functionality has
                                  been successfully restored and is back online.
                                </p>
                                {/* Display the dynamic message */}
                              </div>
                            </marquee>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}

            {isviewlog && (
              <div class="row">
                <div class="col-xxl-8 col-xl-8 col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 p-0">
                        <h5>Instructions/Notifications</h5>
                        <ul
                          class="nav nav-pills nav-warning li-cu"
                          id="j-pills-tab"
                          role="tablist"
                        >
                          <li class="nav-item li-cu">
                            <button
                              class={`nav-link ${
                                activeTab === "instruction_wizard" && "active"
                              } li-cu bor`}
                              id="j-pills-web-designer-tab"
                              data-bs-toggle="pill"
                              role="tab"
                              aria-controls="j-pills-web-designer"
                              aria-selected="true"
                              onClick={() =>
                                handleTabClick("instruction_wizard")
                              }
                            >
                              Instructions
                            </button>
                          </li>
                          <li class="nav-item li-cu">
                            <button
                              class={`nav-link ${
                                activeTab === "notification_wizard" && "active"
                              } li-cu bor`}
                              id="j-pills-UX-designer-tab"
                              data-bs-toggle="pill"
                              role="tab"
                              aria-controls="j-pills-UX-designer"
                              aria-selected="false"
                              onClick={() =>
                                handleTabClick("notification_wizard")
                              }
                            >
                              Notifications
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div class="card-body" style={{ marginBottom: "-35px" }}>
                        <div class="row shopping-wizard">
                          <div class="col-12">
                            <div class="row shipping-form g-5">
                              <div
                                class="col-xl-12"
                                style={{ padding: "0px", marginBottom: "0px" }}
                              >
                                <div
                                  class="dark-field shipping-content clg-dsh-not-msg-cd"
                                  id="cart-options-tabContent"
                                >
                                  {activeTab === "instruction_wizard" && (
                                    <div class="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht ">
                                      <div
                                        className="card-body dark-alert pdg12"
                                        style={{
                                          margin: "1px -20px 0px -19px",
                                        }}
                                      >
                                        {Array.isArray(inst) &&
                                        inst.length > 0 ? (
                                          inst.filter(
                                            (instns) =>
                                              new Date(
                                                instns.msg_exp_time
                                              ).getTime() >=
                                              new Date().getTime()
                                          ).length > 0 ? (
                                            inst
                                              .filter(
                                                (instns) =>
                                                  new Date(
                                                    instns.msg_exp_time
                                                  ).getTime() >=
                                                  new Date().getTime()
                                              )
                                              .map((instns, index) => (
                                                <div
                                                  key={index}
                                                  className={`alert ${
                                                    index % 2 === 0
                                                      ? "alert-light-success"
                                                      : "alert-light-primary"
                                                  }`}
                                                  role="alert"
                                                >
                                                  <div
                                                    style={{
                                                      position: "absolute",
                                                      top: "10px",
                                                      right: "10px",
                                                      fontSize: "smaller",
                                                      color: "gray",
                                                    }}
                                                  >
                                                    {new Date(
                                                      instns.msg_sent_time
                                                    ).toLocaleTimeString()}
                                                  </div>
                                                  <h5 className="alert-heading">
                                                    {instns.subject}
                                                  </h5>

                                                  <p
                                                    style={{
                                                      display: "inline",
                                                    }}
                                                  >
                                                    {instns.status ===
                                                    "sent" ? (
                                                      <label className="badge badge-light-secondary pull-right">
                                                        New
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}

                                                    <span
                                                      style={{
                                                        display: "inline",
                                                      }}
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          instns.message.replace(
                                                            /\r\n/g,
                                                            "<br />"
                                                          ),
                                                      }}
                                                    ></span>
                                                  </p>
                                                </div>
                                              ))
                                          ) : (
                                            <div
                                              className="alert alert-light-success"
                                              role="alert"
                                            >
                                              <h4 className="alert-heading">
                                                No Instructions Available
                                              </h4>
                                              <p>
                                                Currently, there are no
                                                instructions for you to review.
                                                Please check back later .
                                              </p>
                                            </div>
                                          )
                                        ) : (
                                          <div
                                            className="alert alert-light-success"
                                            role="alert"
                                          >
                                            <h4 className="alert-heading">
                                              No Instructions Available
                                            </h4>
                                            <p>
                                              Currently, there are no
                                              instructions for you to review.
                                              Please check back later .
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {activeTab === "notification_wizard" && (
                                    <div class="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht">
                                      <div
                                        className="card-body dark-alert pdg12"
                                        style={{
                                          margin: "1px -20px 0px -19px",
                                        }}
                                      >
                                        {Array.isArray(noti) &&
                                        noti.length > 0 ? (
                                          noti.filter(
                                            (notif) =>
                                              new Date(
                                                notif.msg_exp_time
                                              ).getTime() >=
                                              new Date().getTime()
                                          ).length > 0 ? (
                                            noti
                                              .filter(
                                                (notif) =>
                                                  new Date(
                                                    notif.msg_exp_time
                                                  ).getTime() >=
                                                  new Date().getTime()
                                              )
                                              .map((notif, index) => {
                                                const wordLimit = 15;
                                                const tempDiv =
                                                  document.createElement("div");
                                                tempDiv.innerHTML =
                                                  notif.message;
                                                const fullText =
                                                  tempDiv.textContent ||
                                                  tempDiv.innerText ||
                                                  "";
                                                const words = fullText
                                                  .trim()
                                                  .split(/\s+/);
                                                const showReadMore =
                                                  words.length > wordLimit;
                                                const trimmedText = showReadMore
                                                  ? words
                                                      .slice(0, wordLimit)
                                                      .join(" ") + "..."
                                                  : fullText;
                                                tempDiv.innerHTML = trimmedText;
                                                const trimmedMessage =
                                                  tempDiv.innerHTML;
                                                return (
                                                  <div
                                                    key={index}
                                                    className={`alert ${
                                                      index % 2 === 0
                                                        ? "alert-light-success"
                                                        : "alert-light-primary"
                                                    }`}
                                                    role="alert"
                                                  >
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "10px",
                                                        fontSize: "smaller",
                                                        color: "gray",
                                                      }}
                                                    >
                                                      {new Date(
                                                        notif.msg_sent_time
                                                      ).toLocaleTimeString()}
                                                    </div>

                                                    <h5
                                                      className="alert-heading"
                                                      onClick={() =>
                                                        handleViewModalOpen(
                                                          notif.subject,
                                                          notif.message
                                                        )
                                                      }
                                                    >
                                                      {notif.subject}
                                                    </h5>

                                                    <p
                                                      onClick={() =>
                                                        handleViewModalOpen(
                                                          notif.id,
                                                          notif.subject,
                                                          notif.message,
                                                          notif.status
                                                        )
                                                      }
                                                      style={{
                                                        display: "inline",
                                                      }}
                                                    >
                                                      {notif.status ===
                                                      "sent" ? (
                                                        <label className="badge badge-light-secondary pull-right">
                                                          New
                                                        </label>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <span
                                                        style={{
                                                          display: "inline",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            trimmedMessage.replace(
                                                              /\r\n/g,
                                                              "<br />"
                                                            ),
                                                        }}
                                                      ></span>
                                                      {showReadMore && (
                                                        <span
                                                          style={{
                                                            color: "#2493cc",
                                                            cursor: "pointer",
                                                            display: "inline",
                                                          }}
                                                        >
                                                          read more
                                                        </span>
                                                      )}
                                                    </p>
                                                  </div>
                                                );
                                              })
                                          ) : (
                                            <div
                                              className="alert alert-light-success"
                                              role="alert"
                                            >
                                              <h4 className="alert-heading">
                                                No Notifications Available
                                              </h4>
                                              <p>
                                                Currently, there are no
                                                notifications for you . Please
                                                check back later .
                                              </p>
                                            </div>
                                          )
                                        ) : (
                                          <div
                                            className="alert alert-light-success"
                                            role="alert"
                                          >
                                            <h4 className="alert-heading">
                                              No Notifications Available
                                            </h4>
                                            <p>
                                              Currently, there are no
                                              notifications for you . Please
                                              check back later .
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-xl-4 col-md-4 col-sm-12 notification box-col-6 clg-ml-0 clg-cd-ml-0">
                  <div class="card clg-card-ht">
                    <div class="card-header">
                      <h5>Latest Activity</h5>
                    </div>

                    <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht1">
                      <ul>
                        {flag > 0 ? (
                          userlog.map((log, index) => (
                            <li className="d-flex">
                              <div
                                className={`${
                                  index % 2
                                    ? "activity-dot-primary"
                                    : "activity-dot-warning"
                                } zstl`}
                              />
                              <div className="w-100 ms-3">
                                <p className="d-flex justify-content-between mb-2 clg-not-cd-fnt">
                                  <span className="date-content light-background pdg13">
                                    {formatDate(log.created_at)}
                                  </span>
                                  <span>
                                    {formatRelativeDate(log.created_at)}
                                  </span>
                                </p>
                                <h6 className="clg-not-cd-fnt-h">
                                  {log.master_user_action.user_action}
                                  <span className="dot-notification" />
                                </h6>
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="d-flex">
                            <div className="activity-dot-primary zstl" />
                            <div className="w-100 ms-3">
                              <h6>
                                No Log Data Available
                                <span className="dot-notification" />
                              </h6>
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Container-fluid Ends*/}
      </Template>
    </>
  );
}
